import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowUpFromSquare = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 15,
	viewBox: "0 0 12 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.5 4.67416H9C8.5875 4.67416 8.25 4.98394 8.25 5.36255C8.25 5.74117 8.5875 6.05094 9 6.05094H10.5V13.6232H1.5V6.05094H3C3.4125 6.05094 3.75 5.74117 3.75 5.36255C3.75 4.98394 3.4125 4.67416 3 4.67416H1.5C0.675 4.67416 0 5.29371 0 6.05094V13.6232C0 14.3804 0.675 15 1.5 15H10.5C11.325 15 12 14.3804 12 13.6232V6.05094C12 5.29371 11.325 4.67416 10.5 4.67416Z",
		fill: "#3C59F6"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6 10.1813C6.4125 10.1813 6.75 9.8715 6.75 9.49289V2.60899H8.0925C8.43 2.60899 8.595 2.23726 8.355 2.02386L6.2625 0.103258C6.1125 -0.0344195 5.88 -0.0344195 5.73 0.103258L3.6375 2.02386C3.405 2.23726 3.57 2.60899 3.9075 2.60899H5.25V9.49289C5.25 9.8715 5.5875 10.1813 6 10.1813Z",
		fill: "#3C59F6"
	})]
});
export default SvgArrowUpFromSquare;
